import type { PropsWithChildren } from 'react'

import type { NavLinkProps} from 'react-router-dom';
import { useLocation } from 'react-router-dom'

import testHandle from '../../utils/testHandle'
import { StyledOptionsNavButton, StyledOptionsNavLink } from './OptionsNavLink.styles'

export type OptionsNavLinkProps = PropsWithChildren<{
  to: string
  id: string
  disabled?: boolean
  danger?: boolean
  alwaysRedirect?: boolean
  isActive?: (location: string) => boolean
}> &
  NavLinkProps

const OptionsNavLink = ({
  id,
  to,
  children,
  disabled,
  danger,
  alwaysRedirect,
  isActive: customIsActive,
  ...rest
}: OptionsNavLinkProps) => {
  const defaultIsActive = (match: string) => match !== null
  const isActiveCheck = customIsActive ?? defaultIsActive
  const location = useLocation()

  return disabled ? (
    <StyledOptionsNavButton id={id} data-testid={testHandle(id)} as="button" disabled={disabled} danger={danger}>
      {children}
    </StyledOptionsNavButton>
  ) : (
    <StyledOptionsNavLink
      id={id}
      to={to}
      data-testid={testHandle(id)}
      danger={danger}
      className={isActiveCheck(location?.pathname) ? 'active' : ''}
      {...rest}
      // If the nav page is already active, do not trigger redirect as this can trigger side effects e.g. unsaved change modal
      {...(isActiveCheck(location.pathname) && !alwaysRedirect ? { onClick: (e) => e.preventDefault() } : {})}
    >
      {children}
    </StyledOptionsNavLink>
  )
}

export default OptionsNavLink
